import ShopriteSAML from './ShopriteSAML';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Action Creators
import { createNewUserOrSignIn } from '../../redux/auth/actions';
import { getSSOData } from '../../redux/auth/actions';
import { setLoading } from '../../redux/loading/actions';

// Redux
const mapStateToProps = (state) => {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    createNewUserOrSignIn,
    getSSOData,
    setLoading
  }, dispatch);
}

const ConnectedShopriteSAML = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ShopriteSAML));

export default ConnectedShopriteSAML;



// WEBPACK FOOTER //
// ./src/pages/ShopriteSAML/index.js